import { ChartData, Legends } from 'modules/experience-core';

export enum ChartCategory {
  SALES = 'sales',
  ORDERS = 'orders',
}

export type BarChartDataByCategory = Record<ChartCategory, PerformanceBarChartData[]>;

export enum OrderType {
  NewCustomers = 'NEW_CUSTOMERS',
  ReturningCustomers = 'RETURNING_CUSTOMERS',
}

export type PerformanceBarChartData = ChartData<Legends<OrderType>>;
